const slug = (s) => s.toLowerCase().replace(/[^a-z0-9]+/g, "-");

export default function PDPSpecs({ specs }) {
  return (
    <div data-testid="pdp-specs">
      <p className="eyebrow">Specifications</p>
      <dl className="mt-5 border-t border-white/10">
        {specs.map((s) => (
          <div
            key={s.label}
            className="flex items-baseline justify-between gap-6 py-3.5 border-b border-white/10"
            data-testid={`pdp-spec-${slug(s.label)}`}
          >
            <dt className="text-[0.62rem] uppercase tracking-[0.32em] text-white/50">{s.label}</dt>
            <dd className={s.value ? "font-serif-body text-white/90 text-base" : "font-serif-body italic text-white/40 text-sm"}>
              {s.value || "Details upon request"}
            </dd>
          </div>
        ))}
      </dl>
      <p className="mt-4 text-white/35 text-[0.6rem] uppercase tracking-[0.3em] leading-relaxed">
        Only atelier-verified details are published. Certificates are shared at private viewing.
      </p>
    </div>
  );
}
